module.exports = __webpack_public_path__ + "img/new-bg.89ac39a4.jpg";